export const QUESTION_PLACEHOLDERS: Record<string, string> = {
  // 5F 질문
  "작업 진행 상황이나 결과는 어떤가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 소셜 미디어 플랫폼을 활용한 마케팅이 매출 40% 증대라는 큰 효과를 발휘했다. 특히, 인스타그램과 유튜브에서 인플루언서와의 협업이 제품 인지도와 신뢰도를 높이는 데 크게 기여했고, 다양한 형태의 콘텐츠가 소비자들의 관심을 끌었다.",
  "작업을 하며 어떤 감정들을 느꼈나요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 소셜 미디어에서 고객의 활발한 참여와 긍정적인 피드백을 받으면서 보람을 느꼈다. 그러나 중간에 예기치 않은 문제들도 있었고, 이를 해결하는 과정에서 스트레스를 받기도 했다. 전체적으로는 배우고 성장할 수 있는 좋은 기회였다.",
  "문제점이나 배운점은 무엇이었나요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 캠페인 동안 데이터 분석가의 역할이 매우 중요하다는 것을 배웠다. 실시간 데이터를 분석하고 전략을 조정함으로써 효과적인 결과를 얻을 수 있었다. 특정 소셜 미디어 플랫폼에서의 높은 참여율을 바탕으로 해당 플랫폼에 더 많은 자원을 투입하여 ROI(Return on Investment)를 극대화할 수 있었다.",
  "더 나은 결과를 위해 무엇을 해야 할까요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 데이터 기반의 전략 수립이 중요함을 다시 한 번 깨달았다. 데이터 분석 역량을 더욱 강화하고, 실시간 데이터 모니터링 시스템을 구축할 예정이다. 또한 캠페인 이후에도 고객과의 지속적인 소통과 관리로 마케팅 효과를 유지할 것이다.",
  "지난 회고 내용이 잘 반영되었나요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 캠페인 초기 계획 단계에서 더 철저한 준비가 필요했다. 하지만 팀원들의 협력 덕분에 좋은 결과를 얻을 수 있었다.",

  // KPT 질문
  "어려움을 느꼈던 부분은 무엇인가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 이번 사이드 프로젝트에서 가장 큰 문제는 개발 환경 설정에 많은 시간이 소요되었다는 것입니다. 팀원들마다 사용하고 있는 개발 도구와 환경이 달라서 설정 과정에서 많은 시간이 허비되었습니다. 이로 인해 실제 개발 작업을 시작하는 데 예상보다 더 많은 시간이 걸렸습니다.",
  "계속 유지하고 싶은 것은 무엇인가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 코드 작성 후 즉시 피드백을 받을 수 있도록 설정한 페어 프로그래밍 세션이 매우 유익했습니다. 두 명이 짝을 이루어 코딩하고, 실시간으로 서로의 코드를 검토하면서 문제를 빠르게 해결할 수 있었습니다. 이 덕분에 코드 품질이 향상되었고, 버그 발생률도 줄었습니다. 앞으로도 페어 프로그래밍을 계속 유지하고 싶습니다.",
  "새롭게 시도해볼 내용은 무엇인가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 다음 단계에서는 개발 환경 설정 시간을 줄이기 위해 Docker와 같은 컨테이너 기술을 도입해보려고 합니다. 이를 통해 모든 팀원이 동일한 개발 환경에서 작업할 수 있도록 하고, 설정 과정을 간소화할 수 있을 것입니다. 또한, 환경 설정 가이드를 문서화하여 새로운 팀원이 쉽게 프로젝트에 참여할 수 있도록 하겠습니다.",

  // MAD_SAD_GLAD 질문
  "무엇이 당신을 화나게 하거나 방해하나요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 우리가 마이그레이션 작업을 진행하던 중에 데이터 손실이 발생했습니다. 데이터베이스 백업 절차가 제대로 실행되지 않아 중요한 데이터가 유실되었습니다. 이 문제는 주말 동안 백업 프로세스가 자동화되지 않았기 때문에 발생했으며, 이로 인해 우리 팀은 주말 내내 복구 작업을 해야 했습니다. 앞으로는 모든 중요한 작업 전에 백업 절차를 수동으로라도 확인하고, 자동화된 백업 시스템을 도입할 필요가 있습니다.",
  "무엇이 당신을 속상하게 하거나 실망하게 하나요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 이번 스프린트에서 고객에게 전달된 최종 제품에 몇 가지 중요한 기능이 누락된 것을 발견했습니다. 특히, 사용자 권한 관리 기능이 제대로 작동하지 않아 일부 사용자가 중요한 데이터를 접근할 수 없었습니다. 이 문제의 원인은 요구 사항 정의 단계에서 고객의 요청이 명확하게 문서화되지 않았기 때문입니다. 이로 인해 고객과의 신뢰 관계가 약화될까 봐 걱정이 됩니다. 앞으로는 요구 사항을 더 철저하게 문서화하고, 고객과의 정기적인 체크인 미팅을 통해 요구 사항의 변경 사항을 즉시 반영하도록 하겠습니다.",
  "무엇이 당신을 기쁘게 하나요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 이번 스프린트 동안, 고객으로부터 매우 긍정적인 피드백을 받았습니다. 특히, 우리가 새로 추가한 사용자 인터페이스가 고객들에게 큰 호응을 얻었습니다. 고객들이 인터페이스가 더 직관적이고 사용하기 편리하다고 칭찬해 주셨습니다. 이 기능을 구현하기 위해 팀원들이 야근을 마다하지 않고 열심히 일한 결과라서 정말 뿌듯했습니다. 덕분에 우리 팀의 사기가 크게 올랐고, 앞으로 더 열심히 일할 수 있는 동기부여가 되었습니다.",

  // PMI 질문
  "계획대로 잘 진행된 부분은 무엇이었나요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 프로젝트 초반에 목표와 할 일을 확실하게 정리하고, 모두가 같은 목표를 향해 움직일 수 있도록 진행사항에 우선순위를 부여해두고 진행했습니다. 덕분에 초기 계획된 10개의 주요 기능 중 9개를 기한 내에 성공적으로 구현했으며, 전체 작업 항목의 85%가 예정된 일정에 맞춰 완료되었습니다. ",
  "개선이 필요한 점은 무엇인가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 프로젝트 중간에 요구사항이 바뀌었는데, 이걸 빨리 반영하지 못해서 일정이 조금 밀렸습니다. 그리고 팀원들 간의 소통이 부족해서, 같은 일을 두 번 하거나 놓친 부분이 있었습니다. 앞으로는 더 자주 소통하고, 변화가 생기면 빨리 공유해야 할 것 같습니다.",
  "특히 흥미로웠던 점은 무엇인가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 애자일 방식으로 짧은 기간마다 작업을 검토하면서도 전체적인 계획을 잘 관리한 것이 흥미로웠습니다. 이 덕분에 유연하게 작업하면서도 큰 틀을 놓치지 않을 수 있었고, 이런 방법이 프로젝트에 큰 도움이 된다는 것을 알게 되었습니다.",

  // SSC 질문
  "앞으로 해야할 것은 무엇인가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 사용자 경험을 개선하기 위해 프로젝트 초기 단계에서 더 많은 고객 인터뷰를 진행하려고 합니다. 고객의 니즈와 피드백를 더 잘 반영해 프로젝트가 성공적으로 마무리될 수 있을거라고 기대되요.",
  "성과를 저해하는 요소는 무엇인가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 프로젝트 초기에 요구사항이 불명확하여 중복 작업이 발생했습니다. 요구사항을 명확히 정의하고, 모든 팀원이 이를 공유하여 중복 작업을 줄이면 좋겠습니다.",
  "유지할 것은 무엇인가요?":
    "자유롭게 회고를 작성해주세요 :)\n예시) 매주 진행한 데모 세션은 프로젝트의 진행 상황을 이해하고, 조기 피드백을 받을 수 있는 좋은 기회였어요. 프로젝트 진행 기간동안 계속해서 유지하면 좋겠어요.",

  // 무제 질문
  "자유롭게 회고를 작성해주세요":
    "자유롭게 회고를 작성해주세요 :)\n예시) 이번 자동화 프로젝트를 통해 많은 것을 배우고, 성장할 수 있었다. 팀원들 간의 협업과 소통이 중요하다는 것을 다시 한 번 깨달았고, 이를 통해 코드 품질을 높이는 등의 성과를 달성할 수 있었다. 앞으로의 프로젝트에서도 이번 경험을 바탕으로 더욱 효율적이고, 성공적인 결과를 만들어 나갈 것이다. ",
};

const CUSTOM_PLACEHOLDER = "자유롭게 회고를 작성해주세요 :)";

export const getPlaceholder = (question: string): string => {
  return QUESTION_PLACEHOLDERS[question] || CUSTOM_PLACEHOLDER;
};
